import { StatisticsController } from 'api/controllers/StatisticsController';
import { StatsParams } from 'api/controllers/typings';
import { useQuery } from 'react-query';
import { GET_NOMINATIONS_SENT_STATS } from '../queryKeys';

export function useGetNominationsSentStats(params: StatsParams) {
  return useQuery([GET_NOMINATIONS_SENT_STATS, params], () => StatisticsController.getNominationsSentStats(params));
}
